var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaxyGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 299,
    viewBox: "0 0 309 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_193_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.5 8L158.42 124.724L192.417 12.9919L165.993 126.754L227.75 27.6273L172.783 130.674L258.091 50.9089L178.326 136.217L281.373 81.25L182.246 143.007L296.008 116.583L184.276 150.58L301 154.5L184.276 158.42L296.008 192.417L182.246 165.993L281.373 227.75L178.326 172.783L258.091 258.091L172.783 178.326L227.75 281.373L165.993 182.246L192.417 296.008L158.42 184.276L154.5 301L150.58 184.276L116.583 296.008L143.007 182.246L81.25 281.373L136.217 178.326L50.9089 258.091L130.674 172.783L27.6273 227.75L126.754 165.993L12.9919 192.417L124.724 158.42L8 154.5L124.724 150.58L12.9919 116.583L126.754 143.007L27.6273 81.25L130.674 136.217L50.9089 50.9089L136.217 130.674L81.25 27.6273L143.007 126.754L116.583 12.9919L150.58 124.724L154.5 8Z",
    fill: "#FF8196",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_193_2",
    x: 0,
    y: 0,
    width: 309,
    height: 309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_193_2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxyGlow);
export default __webpack_public_path__ + "static/media/galaxy-glow.f775a8ec78041e2eb14164b505203a90.svg";
export { ForwardRef as ReactComponent };